import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';

export class LoadResourcesWithDefaultPriorityAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        await this.resourceManager.loadResourcesWithDefaultPriority();
    }

    getName(): string {
        return 'LoadResourcesWithDefaultPriorityAct';
    }
}